import { Component, ElementRef } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { CanDeactivateState } from './services/guards/can-deactivate.guard';
import { filter, tap } from 'rxjs/operators';
import { InjectorService } from './services/injector.service';
import { ScreenService } from './services/screen-service.service';
import { BaseComponent } from './models/base/base-component';
import { fromEvent } from 'rxjs';
import { SessionService } from './services/session-service';
import { Meta, Title } from '@angular/platform-browser';
import { PortalService } from './services/portal/portal.service';
import { PortalType } from './models/enum/shared/portal-type';
import { environment } from '../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends BaseComponent {
  constructor(
    private router: Router,
    // @ts-ignore
    private injectorService: InjectorService, // Do not remove, or else injector service does not work.
    private screenService: ScreenService,
    private sessionService: SessionService,
    private el: ElementRef,
    private titleService: Title,
    private portalService: PortalService,
    private meta: Meta,
    private ngbModal: NgbModal
  ) {
    super();

    // Config for Abandon changes on back button
    window.onpopstate = () => (CanDeactivateState.defendAgainstBrowserBackButton = true);
    router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        tap(() => (CanDeactivateState.defendAgainstBrowserBackButton = false))
      )
      .subscribe();

    // Dismiss any open modals when the user navigates via the browser back/forward button.
    // This prevents orphaned modals from persisting after route changes triggered by popstate.
    router.events
      .pipe(
        filter(e => e instanceof NavigationStart),
        filter(e => (e as NavigationStart).navigationTrigger === 'popstate')
      )
      .subscribe(() => this.ngbModal.dismissAll());

    // remove robots meta tag in production
    if (environment.production) {
      this.meta.removeTag('name="robots"');
    }
  }

  setupViews() {
    this.onResize(window?.innerWidth);
  }

  setupBindings() {
    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    fromEvent(window, 'resize').subscribeWhileAlive({
      owner: this,
      next: event => {
        const target = event.target as Window;
        this.onResize(target.innerWidth);
      }
    });

    fromEvent<StorageEvent>(window, 'storage').subscribeWhileAlive({
      owner: this,
      next: (event: StorageEvent) => {
        if (event.key === 'SessionContainer' && event.newValue === null) {
          this.sessionService.destroySession.next(true);
          this.router.navigate(['/auth/sign-in']).then();
        }
      }
    });

    this.portalService.portalType$.subscribeWhileAlive({
      owner: this,
      next: portalType => {
        switch (portalType) {
          case PortalType.Member:
            this.titleService.setTitle($localize`CSS Member`);
            break;
          case PortalType.Employer:
            this.titleService.setTitle($localize`CSS Employer`);
            break;
          case PortalType.Internal:
            this.titleService.setTitle($localize`CSS Internal`);
            break;
          default:
            this.titleService.setTitle($localize`CSS Member`);
        }
      }
    });
  }

  private onResize(windowInnerWidth: number) {
    if (windowInnerWidth > 0) {
      this.screenService.setWidth(windowInnerWidth);
      this.screenService.setIsMobile(windowInnerWidth <= ScreenService.MOBILE_WIDTH);
      this.screenService.setTrueIsMobile(windowInnerWidth <= ScreenService.TRUE_MOBILE_WIDTH);
    }
  }
}
